t = require('app/scripts/views/internal/teacup-with-helpers')('member_application_list')

module.exports = ->
  t.mustacheBlockInverted 'hasTokens', ->
    t.p '.big-link.none', ->
      t.format 'no-applications-are-using-your-trello-account'

  t.mustacheBlock 'hasTokens', ->
    t.div '.member-applications-list.u-gutter.js-list-member-applications'
